/* eslint-disable react/prop-types */
import {
  ControlPosition, Map, MapControl,
  useMapsLibrary,
} from '@vis.gl/react-google-maps'
import React, { useState } from 'react'
import DrawingControl from './DrawingControl'
import PlaceAutocomplete from './PlaceAutocomplete'
import { UndoRedoControl } from './UndoRedoControl'
import { useTerraDraw } from './useTerraDraw'

function MapComponent({ center, onChangePolygon, polygon }) {
  const [loaded, setLoaded] = useState(false)
  useMapsLibrary('places')

  return (
    <>
      <Map
        id="region-polygon-map"
        style={{ width: '100%', height: '100%' }}
        defaultCenter={center}
        defaultZoom={12}
        minZoom={12}
        gestureHandling="greedy"
        disableDefaultUI
        onTilesLoaded={() => setLoaded(true)}
      >
        <TerraDrawControls
          loaded={loaded}
          polygon={polygon}
          onChangePolygon={onChangePolygon}
        />
      </Map>
    </>
  )
}

function TerraDrawControls({ loaded, polygon, onChangePolygon }) {
  const drawing = useTerraDraw({
    enabled: loaded,
    polygon,
    onChangePolygon,
  })

  return (
    <>
      {
        loaded && (
          <>
            <MapControl position={ControlPosition.TOP_LEFT}>
              <div className="m-2">
                <PlaceAutocomplete />
              </div>
            </MapControl>
            <MapControl position={ControlPosition.TOP_RIGHT}>
              <DrawingControl drawing={drawing} />
            </MapControl>
            <MapControl position={ControlPosition.RIGHT_BOTTOM}>
              <UndoRedoControl drawing={drawing} />
            </MapControl>
          </>
        )
      }
    </>
  )
}

export default MapComponent
